import type { Cart } from "./types";

const ATTRIBUTION_KEY = "emynor.storefront.promotion-attribution.v1";

export function storePromotionAttribution(
  attribution: Cart["promotionAttribution"],
): void {
  try {
    if (!attribution) window.localStorage.removeItem(ATTRIBUTION_KEY);
    else
      window.localStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(attribution));
  } catch {
    // The cart still works when browser storage is unavailable.
  }
}

export function storedPromotionAttributionToken(): string | undefined {
  try {
    const raw = window.localStorage.getItem(ATTRIBUTION_KEY);
    if (!raw) return undefined;
    const value = JSON.parse(raw) as Cart["promotionAttribution"];
    if (!value?.token || new Date(value.expiresAt).getTime() <= Date.now()) {
      window.localStorage.removeItem(ATTRIBUTION_KEY);
      return undefined;
    }
    return value.token;
  } catch {
    return undefined;
  }
}
